import React, { Component } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, withStyles, Modal, Box, TextField, Checkbox, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import api from 'services/api';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import DeleteConfirmationModal from 'components/DeleteConfirmationModal/DeleteConfirmationModal';
import CurrencyTextField from '@unicef/material-ui-currency-textfield/dist/CurrencyTextField';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import { ANAO, ASIM } from 'consts';
import { getConfigField } from 'lib/configUtils';
import { ComboPadraoMultiple } from 'views/Components';

const styles = (theme) => ({
    table: {
        minWidth: 650,
    },
    dialogContent: {
        wordWrap: 'break-word',
    },
    dialogTitle: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
    },
    tableContainer: {
        // marginTop: theme.spacing(2),
    },
    tableCell: {
        paddingTop: 5,
        paddingBottom: 5
    }
});

class ComissaoVendedorServico extends Component {
    constructor(props) {
        super(props);
        this.state = {
            comissoes: [],
            qtdeServ: 30,
            nomeServico: '',
            carregando: true,
            janelaPronta: false,
            openAlert: false,
            messageAlert: '',
            listaEmpresas: [],
            empresasSelecionadas: [],
            alturaComissoes: null,
            mensagemEmpresas: ''
        };

        this.filtroNomeRef = React.createRef();
        this.comissoesRef = React.createRef();
    };

    // Método para buscar os dados da API ao montar o componente
    componentDidMount() {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setState({ janelaPronta: true });
            });
        });

        const { codVendedor, comissaoServicos } = this.props;

        if (comissaoServicos !== null) {
            this.setState({
                comissoes: comissaoServicos,
                carregando: false
            });
        } else {
            this.fetchComissoes(codVendedor || 0);
        }

        this.carregarEmpresas();
    }

    // Faz a requisição à API para obter as comissões
    fetchComissoes = async (codVendedor, codigosEmpresas = []) => {
        const altura = this.comissoesRef.current
            ? this.comissoesRef.current.getBoundingClientRect().height
            : null;

        this.setState({
            comissoes: [],
            carregando: true,
            alturaComissoes: altura
        });

        try {
            const response = await api.get(
                `/vendedor/comissaoservico/${codVendedor}`,
                {
                    params: {
                        codigosEmpresas: codigosEmpresas.join(',')
                    }
                }
            );

            this.setState({
                comissoes: response.data,
                qtdeServ: 30
            });
        } catch (error) {
            console.error('Erro ao buscar comissões de serviços:', error);
        } finally {
            this.setState({
                carregando: false,
                alturaComissoes: null
            });
        }
    };

    /* evento on change componentes */
    OnChange = (event) => {
        const { comissoes } = this.state;
        const { name, value, id } = event.target;
        let adjustedValue = value;

        adjustedValue = Number(value.replace(/\./g, '').replace(',', '.'));

        comissoes[id][name] = adjustedValue;
    }

    onClickSave = () => {
        this.atualizaComissaoServico();
    }

    handleCancel = () => {
        this.props.onClose();
    };

    atualizaComissaoServico = () => {
        const { comissoes } = this.state;

        this.props.onSave(comissoes);
    };

    handleOpenAlert = (message) => {
        this.setState({ openAlert: true, messageAlert: message });
    };

    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    carregarMaisServicos = () => {
        this.setState((prevState) => {
            if (prevState.qtdeServ >= prevState.comissoes.length) {
                return null;
            }

            return {
                qtdeServ: Math.min(
                    prevState.qtdeServ + 30,
                    prevState.comissoes.length
                )
            };
        });
    };

    handleFiltroNome = () => {
        clearTimeout(this.timerFiltro);

        this.timerFiltro = setTimeout(() => {
            const nomeServico = this.filtroNomeRef.current.value;

            this.setState({
                nomeServico: nomeServico,
                qtdeServ: 30
            });
        }, 300);
    };

    carregarEmpresas = async () => {
        try {
            const response = await api.get('/empresa');

            const listaEmpresas = response.data.map(empresa => ({
                id: empresa.codigo,
                item: empresa.fantasia
            }));

            const codEmpresa = sessionStorage.getItem('codEmpresa');

            this.setState({
                listaEmpresas,
                empresasSelecionadas: listaEmpresas.filter(
                    empresa => empresa.id == codEmpresa
                )
            });
        } catch (error) {
            console.error('Erro ao carregar empresas:', error);
        }
    };

    OnChangeEmpresas = (empresasSelecionadas) => {
        const codVendedor = this.props.codVendedor || 0;

        const codigosEmpresas = empresasSelecionadas.map(
            empresa => empresa.id
        );

        if (codigosEmpresas.length === 0) {
            const altura = this.comissoesRef.current
                ? this.comissoesRef.current.getBoundingClientRect().height
                : null;

            this.setState({
                comissoes: [],
                carregando: false,
                alturaComissoes: altura,
                mensagemEmpresas: 'Selecione pelo menos uma empresa para visualizar os serviços.'
            });

            return;
        }

        this.setState({
            mensagemEmpresas: ''
        });

        this.fetchComissoes(codVendedor, codigosEmpresas);
    };

    render() {
        const { comissoes, qtdeServ, carregando, janelaPronta, nomeServico } = this.state;
        const { classes } = this.props;

        const controlaliqservnaoesc = getConfigField('controlaliqservnaoesc') == ASIM;
        const calculacomissdedcusto = getConfigField('calculacomissdedcusto') == ASIM;

        const comissoesFiltradas = comissoes.filter((comissao) =>
            (comissao.descservico || '')
                .toLowerCase()
                .includes(nomeServico.trim().toLowerCase())
        );

        return (
            <div>
                <div>
                    <Box
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                            marginBottom: 10
                        }}
                    >
                        <TextField
                            variant="standard"
                            label="Localizar serviço"
                            value={this.state.filtro}
                            onChange={this.handleChangeFiltro}
                            style={{
                                flex: 1,
                                minWidth: 0,
                                marginTop: 0
                            }}
                        />

                        {this.state.listaEmpresas.length > 1 && (
                            <Box
                                style={{
                                    width: '25%',
                                    minWidth: 200,
                                    flexShrink: 0
                                }}
                            >
                                <ComboPadraoMultiple
                                    options={this.state.empresasSelecionadas}
                                    label="Empresas"
                                    itens={this.state.listaEmpresas}
                                    onSelectionChange={this.OnChangeEmpresas}
                                />
                            </Box>
                        )}
                    </Box>

                    <TableContainer
                        ref={this.comissoesRef}
                        component={Paper}
                        className={classes.tableContainer}
                        style={{
                            maxHeight: 400,
                            minHeight: this.state.alturaComissoes
                                ? `${this.state.alturaComissoes}px`
                                : undefined
                        }}
                    >
                        <Table className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.tableCell}>Código</TableCell>
                                    <TableCell className={classes.tableCell}>Serviço</TableCell>
                                    <TableCell className={classes.tableCell}>% Comissão</TableCell>
                                    <TableCell className={classes.tableCell}>% Comissão ADT</TableCell>
                                    <TableCell className={classes.tableCell}>% Comissão CHD</TableCell>
                                    <TableCell className={classes.tableCell}>% Comissão INF</TableCell>
                                    <TableCell className={classes.tableCell}>% Comissão SEN</TableCell>
                                    <TableCell className={classes.tableCell}>Valor pax ADT</TableCell>
                                    <TableCell className={classes.tableCell}>Valor pax CHD</TableCell>
                                    <TableCell className={classes.tableCell}>Valor pax INF</TableCell>
                                    <TableCell className={classes.tableCell}>Valor pax SEN</TableCell>
                                    {controlaliqservnaoesc && (
                                        <TableCell className={classes.tableCell}>Deduz Comiss. Líq.</TableCell>
                                    )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.mensagemEmpresas ? (
                                    <TableRow>
                                        <TableCell
                                            colSpan={controlaliqservnaoesc ? 12 : 11}
                                            align="center"
                                        >
                                            {this.state.mensagemEmpresas}
                                        </TableCell>
                                    </TableRow>
                                ) : carregando || !janelaPronta ? (
                                    <TableRow>
                                        <TableCell colSpan={controlaliqservnaoesc ? 12 : 11} align="center">
                                            Carregando serviços...
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    comissoes
                                        .filter((comissao) => {
                                            const filtro = nomeServico.trim().toLowerCase();

                                            const nome = (comissao.descservico || '').toLowerCase();
                                            const codigo = String(comissao.codservico || '').toLowerCase();

                                            return nome.includes(filtro) || codigo.includes(filtro);
                                        })
                                        .slice(0, qtdeServ)
                                        .map((comissao) => {
                                            const index = comissoes.indexOf(comissao);

                                            return (
                                                <TableRow key={comissao.codservico}>
                                                    <TableCell className={classes.tableCell}>
                                                        {comissao.codservico}
                                                    </TableCell>
                                                    <TableCell className={classes.tableCell}>
                                                        {comissao.descservico}
                                                    </TableCell>

                                                    <TableCell className={classes.tableCell}>
                                                        <CurrencyTextField
                                                            label=""
                                                            name="perccomissao"
                                                            id={String(index)}
                                                            value={comissao.perccomissao || '0'}
                                                            currencySymbol=""
                                                            outputFormat="number"
                                                            decimalCharacter=","
                                                            digitGroupSeparator="."
                                                            onChange={this.OnChange}
                                                            minimumValue="0"
                                                        />
                                                    </TableCell>

                                                    <TableCell className={classes.tableCell}>
                                                        <CurrencyTextField
                                                            label=""
                                                            name="perccomissaoadt"
                                                            id={String(index)}
                                                            value={comissao.perccomissaoadt || '0'}
                                                            currencySymbol=""
                                                            outputFormat="number"
                                                            decimalCharacter=","
                                                            digitGroupSeparator="."
                                                            onChange={this.OnChange}
                                                            minimumValue="0"
                                                            disabled={calculacomissdedcusto || !(comissao.servicopasseio == ASIM || comissao.servicotransporte == ASIM)}
                                                        />
                                                    </TableCell>

                                                    <TableCell className={classes.tableCell}>
                                                        <CurrencyTextField
                                                            label=""
                                                            name="perccomissaochd"
                                                            id={String(index)}
                                                            value={comissao.perccomissaochd || '0'}
                                                            currencySymbol=""
                                                            outputFormat="number"
                                                            decimalCharacter=","
                                                            digitGroupSeparator="."
                                                            onChange={this.OnChange}
                                                            minimumValue="0"
                                                            disabled={calculacomissdedcusto || !(comissao.servicopasseio == ASIM || comissao.servicotransporte == ASIM)}
                                                        />
                                                    </TableCell>

                                                    <TableCell className={classes.tableCell}>
                                                        <CurrencyTextField
                                                            label=""
                                                            name="perccomissaoinf"
                                                            id={String(index)}
                                                            value={comissao.perccomissaoinf || '0'}
                                                            currencySymbol=""
                                                            outputFormat="number"
                                                            decimalCharacter=","
                                                            digitGroupSeparator="."
                                                            onChange={this.OnChange}
                                                            minimumValue="0"
                                                            disabled={calculacomissdedcusto || !(comissao.servicopasseio == ASIM || comissao.servicotransporte == ASIM)}
                                                        />
                                                    </TableCell>

                                                    <TableCell className={classes.tableCell}>
                                                        <CurrencyTextField
                                                            label=""
                                                            name="perccomissaosen"
                                                            id={String(index)}
                                                            value={comissao.perccomissaosen || '0'}
                                                            currencySymbol=""
                                                            outputFormat="number"
                                                            decimalCharacter=","
                                                            digitGroupSeparator="."
                                                            onChange={this.OnChange}
                                                            minimumValue="0"
                                                            disabled={calculacomissdedcusto || !(comissao.servicopasseio == ASIM || comissao.servicotransporte == ASIM)}
                                                        />
                                                    </TableCell>

                                                    <TableCell className={classes.tableCell}>
                                                        <CurrencyTextField
                                                            label=""
                                                            name="valorporpax"
                                                            id={String(index)}
                                                            value={comissao.valorporpax || '0'}
                                                            currencySymbol=""
                                                            outputFormat="number"
                                                            decimalCharacter=","
                                                            digitGroupSeparator="."
                                                            onChange={this.OnChange}
                                                            minimumValue="0"
                                                        />
                                                    </TableCell>

                                                    <TableCell className={classes.tableCell}>
                                                        <CurrencyTextField
                                                            label=""
                                                            name="valorporpaxchd"
                                                            id={String(index)}
                                                            value={comissao.valorporpaxchd || '0'}
                                                            currencySymbol=""
                                                            outputFormat="number"
                                                            decimalCharacter=","
                                                            digitGroupSeparator="."
                                                            onChange={this.OnChange}
                                                            minimumValue="0"
                                                        />
                                                    </TableCell>

                                                    <TableCell className={classes.tableCell}>
                                                        <CurrencyTextField
                                                            label=""
                                                            name="valorporpaxinf"
                                                            id={String(index)}
                                                            value={comissao.valorporpaxinf || '0'}
                                                            currencySymbol=""
                                                            outputFormat="number"
                                                            decimalCharacter=","
                                                            digitGroupSeparator="."
                                                            onChange={this.OnChange}
                                                            minimumValue="0"
                                                        />
                                                    </TableCell>

                                                    <TableCell className={classes.tableCell}>
                                                        <CurrencyTextField
                                                            label=""
                                                            name="valorporpaxsen"
                                                            id={String(index)}
                                                            value={comissao.valorporpaxsen || '0'}
                                                            currencySymbol=""
                                                            outputFormat="number"
                                                            decimalCharacter=","
                                                            digitGroupSeparator="."
                                                            onChange={this.OnChange}
                                                            minimumValue="0"
                                                        />
                                                    </TableCell>
                                                    {controlaliqservnaoesc && (
                                                        <TableCell className={classes.tableCell}>
                                                            <Checkbox
                                                                size="small"
                                                                checked={comissao.calculacomissobreliquido === ASIM}
                                                                onChange={(event) => {
                                                                    const valor = event.target.checked ? ASIM : ANAO;

                                                                    this.setState((prevState) => {
                                                                        const novasComissoes = [...prevState.comissoes];
                                                                        const indice = novasComissoes.findIndex(
                                                                            item => item.codservico === comissao.codservico
                                                                        );

                                                                        if (indice === -1) {
                                                                            return null;
                                                                        }

                                                                        novasComissoes[indice] = {
                                                                            ...novasComissoes[indice],
                                                                            calculacomissobreliquido: valor
                                                                        };

                                                                        return { comissoes: novasComissoes };
                                                                    });
                                                                }}
                                                                color="primary"
                                                            />
                                                        </TableCell>
                                                    )}
                                                </TableRow>
                                            );
                                        })
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>

                <Box style={{ float: 'right' }}>
                    <Button
                        color="primary"
                        onClick={this.handleCancel}
                    >
                        Fechar
                    </Button>

                    <Button
                        color="primary"
                        onClick={this.onClickSave}
                        style={{ marginRight: '5px' }}
                    >
                        Salvar
                    </Button>
                </Box>

                <div>
                    <AlertInformation
                        open={this.state.openAlert}
                        handleClose={this.handleCloseAlert}
                        message={this.state.messageAlert}
                    />
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(ComissaoVendedorServico);